import React, { Component } from 'react';
import SpinnerIcon from '../Custom/SpinnerIcon';

class ActivityIndicator extends Component {
  render() {
    const { isLoading } = this.props;
    if (isLoading) {
      document.body.classList.add('scroll-hide');
    } else {
      document.body.classList.remove('scroll-hide');
    }
    return isLoading ? (
      <div className="activity-indicator">
        <div className="spinner">
          <SpinnerIcon />
        </div>
      </div>
    ) : null;
  }
}

export default ActivityIndicator;
